export const config = {
  BASE_URL: 'https://shoes.ptjdy.com/api',
  WS_URL: 'wss://shoes.ptjdy.com/api'
  // BASE_URL: 'http://192.168.110.100:50100/shoes',
  // WS_URL: 'ws://192.168.110.100:50100/shoes'
}
